export default "__VITE_ASSET__DMLExVY3__"